import useLogbook from '@/hooks/useLogbook';
import useSaveGeneralResult from '@/hooks/useSaveGeneralResult';
import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import studiesConst from '@/constants/studiesConst';
import {useParams, useSearchParams} from 'react-router-dom';
import {Toast, ToastContainer} from 'react-bootstrap';
import classNames from '@/helpers/classNames';
import './StopProgressForm.scss';

function StopProgressForm({
  isStopProgressActive,
  setIsStopProgressActive,
  isStudyCancelled,
  isPendingCancel,
}) {
  const {assessmentId} = useParams();
  const [searchParams] = useSearchParams();
  const {logbook, mutate} = useLogbook({
    assessmentId: assessmentId || searchParams.get('id'),
  });
  const [stopMotive, setStopMotive] = useState('');
  const [isGeneralResultSavingToastShowing, setIsGeneralResultSavingToastShowing] = useState(false);
  const {
    trigger: saveGeneralResult, 
    isMutating: isSaveGeneralResultMutating,
    isError: isGeneralResultSaveError,
    reset: resetGeneralResultSaveMutation,
  } = useSaveGeneralResult({
    assessmentId: logbook?.id,
  });
  const isGeneralResultSaveSuccessToastShowing =
  !isGeneralResultSaveError && !isSaveGeneralResultMutating && isGeneralResultSavingToastShowing;

  useEffect(() => {
    if (isSaveGeneralResultMutating) {
      setIsGeneralResultSavingToastShowing(true);
    }
  }, [isSaveGeneralResultMutating]);
  const handleToastAfterGeneralResultSave = () => {
    setIsGeneralResultSavingToastShowing(false);
    resetGeneralResultSaveMutation();
  };

  const onStopConfirmation = () => {
    const analysisValues = {
      assessmentStatus: isPendingCancel
        ? studiesConst.assessmentStatus.pendingCancel
        : studiesConst.assessmentStatus.invalid,
      reason: stopMotive,
    };

    saveGeneralResult(JSON.stringify(analysisValues)).then(() => mutate());
  };

  if (stopMotive === '' && logbook?.cancellationReason) {
    setStopMotive(logbook?.cancellationReason);
  }

  return isStopProgressActive ? (
    <div className="stop-progress-form mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="reason-label">
          {isStudyCancelled
            ? 'Se solicitó detener el proceso'
            : 'Escribe el motivo por el cual deseas detener el proceso'}
        </div>
        {!isStudyCancelled && (
          <i
            className="bi bi-x-circle "
            role="button"
            onClick={() => {
              setIsStopProgressActive(false);
              setStopMotive('');
            }}
          />
        )}
      </div>
      <textarea
        className="form-control mt-2 mb-2"
        onChange={(e) => setStopMotive(e.target.value)}
        value={stopMotive}
        rows="3"
        disabled={logbook?.cancellationReason}
      />
      <div className="w-100 d-flex justify-content-end">
        {!isStudyCancelled && (
          <button
            type="button"
            {...classNames(
              'btn progress-btn progress-btn-confirm',
              isPendingCancel ? 'btn-warning' : 'btn-success'
            )}
            onClick={onStopConfirmation}
            disabled={isSaveGeneralResultMutating}
          >
            Confirmar
          </button>
        )}
      </div>
      <ToastContainer className="m-4" position="top-center">
          <Toast
            className={`text-bg-${
              isGeneralResultSaveSuccessToastShowing
                ? 'success'
                : isGeneralResultSaveError
                ? 'danger'
                : 'warning'
            }`}
            show={isGeneralResultSavingToastShowing}
            onClose={handleToastAfterGeneralResultSave}
            autohide
            delay={5000}
          >
            <Toast.Body>
              {!isGeneralResultSaveError && isSaveGeneralResultMutating && (
                <>
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Guardando, por favor no cierre el navegador o la pestaña...
                </>
              )}
              {isGeneralResultSaveError &&
                'Error al detener el proceso, intenta de nuevo en unos segundos...'}
              {isGeneralResultSaveSuccessToastShowing && '¡Estudio guardado con éxito!'}
            </Toast.Body>
          </Toast>
        </ToastContainer>
    </div>
  ) : null;
}

StopProgressForm.propTypes = {
  isStopProgressActive: PropTypes.bool,
  setIsStopProgressActive: PropTypes.func,
  isStudyCancelled: PropTypes.bool,
  isPendingCancel: PropTypes.bool,
};

export default StopProgressForm;
